import React, { useEffect, useState } from "react";
import "./TrackStatus.css";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  getForReceived,
  getForDdTransit,
  getForMrTransit,
  getForDdDo,
} from "../_actions/grnAction";
import { getAsns } from "../_actions/asnAction";
import Moment from "react-moment";
import moment from "moment";

const TrackStatus = ({
  match,
  getForReceived,
  getForDdTransit,
  getForMrTransit,
  getForDdDo,
  mrTransit,
  ddTransit,
  received,
  getAsns,
  asns,
  asnUploadDate,
  transDate,
  transDateForDirect,
  transDateForReceive,
  transDateForDoDirect,
  manualAsn,
  manualGrn,
  giNoForGRN,
  giNoForDD,
  giNoForDO,
  giNoForDODD,
  ddDo,
}) => {
  var newDate = new Date();

  Date.prototype.toShortFormat = function () {
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let day = this.getDate();

    let monthIndex = this.getMonth();
    let monthName = monthNames[monthIndex];

    let year = this.getFullYear();

    return `${day}-${monthName}-${year}`;
  };

  const deliveryLocation = () => {
    // try a few possible fields and return a readable fallback instead of null
    const pick = (obj, keys) => {
      if (!obj) return null;
      for (let k of keys) {
        if (obj[k]) return obj[k];
      }
      return null;
    };

    const srcs = [asns, received, mrTransit, ddTransit, ddDo];
    for (let s of srcs) {
      if (s && s.results > 0 && s.data && s.data.data && s.data.data[0]) {
        const item = s.data.data[0];
        const val = pick(item, [
          'deliveryLocation',
          'deliveryLocationName',
          'pickupLocation',
          'pickupAddress',
          'vendorAddress'
        ]);
        if (val) return val;
      }
    }

    return 'N/A';
  };

  const vehicleNumber = () => {
    // prefer DO (ddDo) over GRN/ASN for vehicle number; fall back to other sources
    const srcs = [ddDo, ddTransit, mrTransit, received, asns];
    for (let s of srcs) {
      if (s && s.results > 0 && s.data && s.data.data && s.data.data[0]) {
        const item = s.data.data[0];
        // common field names
        if (item.vehicleNumber) return item.vehicleNumber;
        if (item.vehicleNo) return item.vehicleNo;
        // possible typo/alternate
        if (item.vechileNumber) return item.vechileNumber;
        // sometimes vehicle number may be nested under a 'details' object
        if (item.details && item.details.vehicleNumber) return item.details.vehicleNumber;
      }
    }
    return 'N/A';
  };

  const store = () => {
    const srcs = [asns, received, mrTransit, ddTransit, ddDo];
    for (let s of srcs) {
      if (s && s.results > 0 && s.data && s.data.data && s.data.data[0]) {
        const item = s.data.data[0];
        if (item.store) return item.store;
        if (item.storeName) return item.storeName;
      }
    }
    return 'N/A';
  };

  const operateDeliveryDate = (tDate) => {
    var months = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11,
    };
    var p = tDate.split("-");
    return new Date(p[2], months[(p[1] || "").toLowerCase()], p[0]);
  };

  const [state, setState] = useState({
    deliveryDate: "",
    currentDate: newDate.toShortFormat(),
    dispatchDate: "",
    dispatchGreaterCurrent: false,
  });

  const [planDate, setPlanDate] = useState();

  const { deliveryDate } = state;

  // compute whether delivery date has passed by day (delivered only when current day is after delivery day)
  // also, when delivery location is TSM, show the date one day ahead (and compare against that)
  let deliveryMoment = null;
  let displayMoment = null;
  let isDelivered = false;
  if (deliveryDate && deliveryDate !== "NaN-undefined-NaN") {
    // deliveryDate format is like '08-Jan-2026' or '8-Jan-2026'
    const baseMoment = moment(deliveryDate, "D-MMM-YYYY");
    if (baseMoment.isValid()) {
      const loc = (deliveryLocation() || "").toString().trim().toUpperCase();
      // If delivery location contains TSM, compute displayed/comparison date as dispatch/transDate + 2 days
      // use includes to tolerate values like 'TSM SHOP' or 'TSM - ABC'
      if (loc.includes("TSM")) {
        // try to pick a dispatch/transDate from the available sources
        let dispatchDate = null;
        const srcs = [mrTransit, received, ddTransit, ddDo, asns];
        for (let i = 0; i < srcs.length; i++) {
          const s = srcs[i];
          if (!s) continue;
          if (s.results > 0 && s.data && s.data.data && s.data.data[0]) {
            const item = s.data.data[0];
            if (item.transDate) {
              dispatchDate = item.transDate;
              break;
            }
            if (item.inDate) {
              dispatchDate = item.inDate;
              break;
            }
          }
        }

        if (dispatchDate) {
          // compute expected date as dispatch/transDate + 3 days for TSM
          displayMoment = moment(dispatchDate).clone().add(3, "day");
        } else {
          // fallback: use computed delivery date and add 3 days
          displayMoment = baseMoment.clone().add(3, "day");
        }
      } else {
        displayMoment = baseMoment.clone();
      }

      deliveryMoment = baseMoment;
      // delivered only when current date is strictly after the displayMoment (so full display day counts as Expected)
      isDelivered = moment().isAfter(displayMoment, "day");
    }
  }

  function parseDate(s) {
    var months = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11,
    };
    var p = s.split("-");
    return new Date(p[2], months[(p[1] || "").toLowerCase()], p[0]);
  }

  Date.prototype.toShortFormat = function () {
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let day = this.getDate();

    let monthIndex = this.getMonth();
    let monthName = monthNames[monthIndex];

    let year = this.getFullYear();

    return `${day}-${monthName}-${year}`;
  };

  useEffect(() => {
    if (mrTransit.results > 0) {
      if (mrTransit.data.data[0].transDate) {
        let dispatchDate = mrTransit.data.data[0].transDate;
        setState({
          ...state,
          dispatchDate: dispatchDate,
        });
      }
    } else if (received.results > 0) {
      if (received.data.data[0].transDate) {
        let dispatchDate = received.data.data[0].transDate;
        setState({
          ...state,
          dispatchDate: dispatchDate,
        });
      }
    }
  }, []);

  useEffect(() => {
    getAsns(match.params.id);
    getForReceived(match.params.id);
    getForDdTransit(match.params.id);
    getForMrTransit(match.params.id);
    getForDdDo(match.params.id);

    var transDateFromReport;
    if (transDate) {
      transDateFromReport = increaseDateBy1(transDate);
    } else if (transDateForReceive) {
      transDateFromReport = increaseDateBy1(transDateForReceive);
    } else if (transDateForDoDirect) {
      transDateFromReport = increaseDateBy1(transDateForDoDirect);
    } else {
      transDateFromReport = increaseDateBy1(transDateForDirect);
    }
    var transDateIntoJSDate = new Date(transDateFromReport);
    var transDay = transDateIntoJSDate.getDay();

    if (transDay === 6) {
      var increasedDateBy1 = new Date(
        transDateIntoJSDate.setDate(transDateIntoJSDate.getDate() + 2)
      );

      var finalDeliveryDate = increasedDateBy1.toShortFormat();

      const firstPart = finalDeliveryDate.split("-")[0];

      if (firstPart.length > 1) {
        setState({ ...state, deliveryDate: finalDeliveryDate });
      } else {
        setState({ ...state, deliveryDate: "0" + finalDeliveryDate });
      }
    } else {
      var increasedDateBy2 = new Date(
        transDateIntoJSDate.setDate(transDateIntoJSDate.getDate() + 1)
      );

      var finalDeliveryDate2 = increasedDateBy2.toShortFormat();
      const firstPart2 = finalDeliveryDate2.split("-")[0];

      if (firstPart2.length > 1) {
        setState({ ...state, deliveryDate: finalDeliveryDate2 });
      } else {
        setState({ ...state, deliveryDate: "0" + finalDeliveryDate2 });
      }
    }

    //
  }, [
    asnUploadDate,
    transDate,
    transDateForDirect,
    transDateForReceive,
    transDateForDoDirect,
  ]);

  const vendor = () => {
    if (asns.results > 0) {
      return asns.data.data[0].vendorName;
    } else if (received.results > 0) {
      return received.data.data[0].vendorName;
    } else if (mrTransit.results > 0) {
      return mrTransit.data.data[0].vendorName;
    } else if (ddTransit.results > 0) {
      return ddTransit.data.data[0].vendorName;
    } else if (ddDo.results > 0) {
      return ddDo.data.data[0].vendorName;
    } else {
      return null;
    }
  };

  const warehouse = () => {
    const srcs = [asns, received, mrTransit, ddTransit, ddDo];
    for (let s of srcs) {
      if (s && s.results > 0 && s.data && s.data.data && s.data.data[0]) {
        const item = s.data.data[0];
        if (item.warehouse) return item.warehouse;
        if (item.collectionLocation) return item.collectionLocation;
        if (item.pickupLocation) return item.pickupLocation;
        if (item.pickupAddress) return item.pickupAddress;
        if (item.vendorAddress) return item.vendorAddress;
      }
    }
    return 'N/A';
  };

  // short code for collection location: show 'JSR' when warehouse contains 'JSR', otherwise 'KOL'
  const collectionCode = () => {
    const w = warehouse();
    if (!w || w === 'N/A') return w;
    const up = w.toString().toUpperCase();
    if (up.includes('JSR')) return 'JSR';
    return 'KOL';
  };

  function increaseDateBy1(s, manual) {
    if (!manual) {
      var d = moment(s).toDate();
      var increasePlanDate = new Date(d.setDate(d.getDate() + 1));

      return increasePlanDate;
    } else {
      return s;
    }
  }

  return (
    <div className='status'>
      <div className='status-overlay'>
        <div className='status-inner'>
          <div className='container-fluid'>
            <div className='row pb-5 two-column'>
              {/* Left column: timeline steps */}
              <div className='col-md-5 col-sm-12 animated shadow-lg fadeIn bg-white mb-5 p-4'>
                <div className='timeline-inner'>

                  <div className='step step0 pb-3 pt-1'>
                    <i
                      className={`fa fa-map ${asnUploadDate ? "text-primary" : "text-danger"
                        } mr-3 border p-1 `}
                    ></i>
                    <div className='step-body'>
                      <span className='pill pill-planned'>Planned for Picking</span>
                      <small className='pill-date'>
                        {asnUploadDate ? (
                          <Moment format='DD-MMM-YYYY'>
                            {increaseDateBy1(asnUploadDate)}
                          </Moment>
                        ) : (
                          ""
                        )}
                      </small>
                    </div>
                  </div>

                  <div className='step step0 pb-3 pt-1'>
                    <i
                      className={`fa fa-shopping-basket ${mrTransit.results > 0
                        ? "text-primary"
                        : received.results > 0
                          ? "text-primary"
                          : ddTransit.results > 0
                            ? "text-primary"
                            : ddDo.results > 0
                              ? "text-primary"
                              : "text-danger"
                        } mr-3 border p-1 `}
                    ></i>
                    <div className='step-body'>
                      <span className='pill pill-picked'>Picked from Vendor Location</span>
                      {mrTransit.results > 0 ||
                        received.results > 0 ||
                        ddTransit.results > 0 ||
                        ddDo.results > 0 ? (
                        <small className='pill-date'>
                          <Moment format='DD-MMM-YYYY'>
                            {increaseDateBy1(
                              mrTransit.results > 0
                                ? mrTransit.data.data[0].inDate
                                : received.results > 0
                                  ? received.data.data[0].inDate
                                  : ddTransit.results > 0
                                    ? ddTransit.data.data[0].inDate
                                    : ddDo.results > 0
                                      ? ddDo.data.data[0].inDate
                                      : "",
                              mrTransit.results > 0
                                ? mrTransit.data.data[0].manual
                                : received.results > 0
                                  ? received.data.data[0].manual
                                  : ddTransit.results > 0
                                    ? ddTransit.data.data[0].manual
                                    : ddDo.results > 0
                                      ? ddDo.data.data[0].manual
                                      : ""
                            )}
                          </Moment>
                        </small>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {ddTransit.results > 0 || ddDo.results > 0 ? null : (
                    <div className='step step1 pb-3 pt-1'>
                      <i
                        className={`fa fa-cube ${mrTransit.results > 0
                          ? "text-primary"
                          : received.results > 0
                            ? "text-primary"
                            : "text-danger"
                          } mr-3 border p-1 `}
                      ></i>
                      <div className='step-body'>
                        <span className='pill pill-received'>Received at OWM Cross-dock</span>
                        {mrTransit.results > 0 || received.results > 0 ? (
                          <small className='pill-date'>
                            <Moment format='DD-MMM-YYYY'>
                              {increaseDateBy1(
                                mrTransit.results > 0
                                  ? mrTransit.data.data[0].inDate
                                  : received.results > 0
                                    ? received.data.data[0].inDate
                                    : "",
                                mrTransit.results > 0
                                  ? mrTransit.data.data[0].manual
                                  : received.results > 0
                                    ? received.data.data[0].manual
                                    : ""
                              )}
                            </Moment>
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}

                  {giNoForGRN || giNoForDD || giNoForDO || giNoForDODD ? (
                    ddTransit.results > 0 || ddDo.results > 0 ? null : (
                      <div className='step step2 pb-3 pt-1'>
                        <i
                          className={`fa fa-truck ${mrTransit.results > 0
                            ? "text-primary"
                            : received.results > 0
                              ? "text-primary"
                              : "text-danger"
                            } mr-3 border p-1 `}
                        ></i>
                        <div className='step-body'>
                          <span className='pill pill-dispatched'>Dispatched from OWM Cross-dock</span>
                          {mrTransit.results > 0 || received.results > 0 ? (
                            <small className='pill-date'>
                              <Moment format='DD-MMM-YYYY'>
                                {increaseDateBy1(
                                  mrTransit.results > 0
                                    ? mrTransit.data.data[0].transDate
                                    : received.results > 0
                                      ? received.data.data[0].transDate
                                      : "",
                                  mrTransit.results > 0
                                    ? mrTransit.data.data[0].manual
                                    : received.results > 0
                                      ? received.data.data[0].manual
                                      : ""
                                )}
                              </Moment>
                            </small>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    )
                  ) : (
                    <div className='step step2 pb-3 pt-1'>
                      <i
                        className={`fa fa-truck text-danger mr-3 border p-1 `}
                      ></i>
                      Dispatched form OWM Cross-dock <br />
                    </div>
                  )}

                  {giNoForGRN || giNoForDD || giNoForDO || giNoForDODD ? (
                    <div className='step step1 pb-3 pt-1'>
                      <i
                        className={`fa fa-dropbox ${!isDelivered ? "text-danger" : "text-primary"} mr-3 border p-1 `}
                      ></i>
                      <div className='step-body'>
                        <span className={`pill ${!isDelivered ? 'pill-expected' : 'pill-delivered'}`}>
                          {!isDelivered ? "Expected Delivery at Tata Steel" : "Delivered at Tata Steel"}
                        </span>
                        <small className='pill-date'>
                          <Moment format='DD-MMM-YYYY'>
                            {displayMoment
                              ? displayMoment.toDate()
                              : deliveryDate !== "NaN-undefined-NaN"
                                ? deliveryDate
                                : ""}
                          </Moment>
                        </small>
                      </div>
                    </div>
                  ) : (
                    <div className='step step1 pb-3 pt-1'>
                      <i className={`fa fa-dropbox text-danger mr-3 border p-1 `}></i>
                      Delivered at Tata Steel
                      <br />
                    </div>
                  )}
                </div>
              </div>

              {/* Right column: details card */}
              <div className='col-md-7 col-sm-12 animated shadow-lg fadeIn bg-white mb-5 p-4'>
                <div className='details-inner'>
                  {/* <h4>Details:</h4> */}

                  <div className='details-row' style={{ marginTop: 18 }}>
                    <div style={{ color: "#f28e05", fontWeight: 500 }}>ECCI: #{match.params.id}</div>
                  </div>

                  <hr />

                  <div className='details-block' style={{ color: "#017028", marginTop: 8 }}>
                    <div style={{ fontWeight: 700, marginBottom: 8 }}>Vendor: {vendor()}</div>
                    <div style={{ marginBottom: 6 }}>
                      <span style={{ fontWeight: 600 }}>Collection Location:</span>{' '}{collectionCode()}
                    </div>

                    {/* <div style={{ marginBottom: 6 }}>
                      Pickup Location:{' '}
                      {asns && asns.results > 0
                        ? (asns.data.data[0].pickupLocation || asns.data.data[0].pickupAddress || asns.data.data[0].vendorAddress || "")
                        : received && received.results > 0
                          ? (received.data.data[0].pickupLocation || received.data.data[0].pickupAddress || "")
                          : ''}
                    </div> */}
                  </div>

                  <hr />

                  <div className='details-foot' style={{ marginTop: 12, color: "#1b4b6b" }}>
                    <div style={{ marginBottom: 6 }}>
                      <span style={{ fontWeight: 600 }}>Delivery Location:</span>{' '}{deliveryLocation()}
                    </div>
                    <div style={{ marginBottom: 6 }}>
                      <span style={{ fontWeight: 600 }}>Store:</span>{' '}{store()}
                    </div>
                    <div style={{ marginBottom: 6 }}>
                      <span style={{ fontWeight: 600 }}>Vehicle Number:</span>{' '}{vehicleNumber()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer mt-4 text-dark">
        <p style={{ fontSize: '13px' }} className="text-black">
          &copy; {new Date().getFullYear()}, OWM Logistics | Developed By{' '}
          <a href="http://globuslabs.com" className="text-dark" target="_blank">
            Globus Labs
          </a>{' '}
          (Official IT Partner)
        </p>
      </div>
      <Link to='/' className='fab'>
        <i className='fa fa-search my-fab'></i>
      </Link>
    </div>
  );
};

TrackStatus.propTypes = {
  getForReceived: PropTypes.func.isRequired,
  getAsns: PropTypes.func.isRequired,
  getForDdTransit: PropTypes.func.isRequired,
  getForMrTransit: PropTypes.func.isRequired,
  getForDdDo: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  received: state.grn.received,
  asns: state.asn.asns,
  loading: state.asn.loading,
  asnUploadDate: state.asn.asnUploadDate,
  manualAsn: state.asn.manual,
  manualGrn: state.grn.manual,
  transDate: state.grn.transDate,
  transDateForReceive: state.grn.transDateForReceive,
  transDateForDirect: state.grn.transDateForDirect,
  transDateForDoDirect: state.grn.transDateForDoDirect,
  giNoForGRN: state.grn.giNoForGRN,
  giNoForDO: state.grn.giNoForDO,
  giNoForDD: state.grn.giNoForDD,
  giNoForDODD: state.grn.giNoForDODD,
  mrTransit: state.grn.mrTransit,
  ddTransit: state.grn.ddTransit,
  ddDo: state.grn.ddDo,
});
export default connect(mapStateToProps, {
  getForReceived,
  getAsns,
  getForDdTransit,
  getForMrTransit,
  getForDdDo,
})(TrackStatus);
